const PaymentChannelEditValidation = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  if (values.account_no) {
    if (!values.account_no.match(/^[0-9]{3}-[0-9]{1}-[0-9]{5}-[0-9]{1}$/)) {
      errors.account_no = "Account No. should match xxx-x-xxxxx-x";
    }
  }

  return errors;
};

export default PaymentChannelEditValidation;
